import { Component, Input } from '@angular/core';
import { Stipulation } from './models/stipulation.interface';

@Component({
  selector: 'idp-stipulation',
  templateUrl: './stipulation.component.html',
  styleUrls: ['./stipulation.component.scss']
})
export class StipulationComponent {
  @Input() content: Stipulation = {} as Stipulation;
}
